module.exports = __webpack_public_path__ + "static/16-a82e3d15c5fb9b13e4e460f1320322d4.jpg";